import styled, { css } from 'styled-components'
import { ReactComponent as SymbolIconSvg } from '@sketch/icons/arrow-circle-right-16'
import { Rect } from 'modules/shares/types'

const MIN_SYMBOL_NAME_WITDH = 60

const SymbolContainer = styled.div<{ frame: Rect }>(
  ({ theme, frame }) => css`
    position: absolute;
    top: ${frame.y}px;
    left: ${frame.x}px;
    width: ${frame.width}px;
    height: ${frame.height}px;
    border: 2px solid ${theme.colors.inspect.symbol.A};
    background: ${theme.colors.inspect.symbol.B};
  `
)

/* Show symbol name on top, truncated if needed */
const SymbolNameContainer = styled.div<{
  frame: Rect
  isLongName?: boolean
}>(
  ({ theme, isLongName, frame }) => css`
    display: flex;
    align-items: flex-end;

    min-width: ${MIN_SYMBOL_NAME_WITDH}px;
    height: 20px;

    position: absolute;
    top: -22px;
    z-index: 1; /* Symbol name will be placed below measurements and grid but should be clickable (if applies) */

    line-height: 1.2;
    font-size: 0.75rem;
    font-weight: ${theme.fontWeights.medium};

    /* Rounded right border */
    ${!isLongName &&
    css`
      ::after {
        content: '';
        display: ${frame.width < MIN_SYMBOL_NAME_WITDH && 'none'};
        width: 4px;
        height: 4px;
        border-bottom-left-radius: 4px;
        box-shadow: -1px 1px 0px 1px ${theme.colors.inspect.symbol.A};
      }
    `}
  `
)

const SymbolLabel = styled.div<{
  width?: number
}>(
  ({ theme, width }) => css`
    display: inline-flex;
    align-items: center;
    padding: 0 4px;
    max-width: ${width ? `${width}px` : '100%'};
    background: ${theme.colors.inspect.symbol.A};
    border-radius: 4px 4px 0 0;
    height: 17px;

    /* This needs to be white for any theme because the background is always purple */
    color: white;
  `
)

const StyledVersionLink = styled.div`
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  margin: 0 -2px 0 2px; /* stylelint-disable-line scales/space */
`

const SymbolIcon = styled(SymbolIconSvg)``

export {
  SymbolContainer,
  SymbolIcon,
  StyledVersionLink,
  SymbolNameContainer,
  SymbolLabel,
}
